<template>
    <div v-dusk="'check-existing-order'" class="check-existing-order">
        <ErrorsZone :errors="errors" />

        <div v-if="loading">
            <i class="fad fa-spinner fa-spin"></i> Recherche de commande existante...
        </div>
        <div v-else-if="existingOrder" class="alert alert-warning">
            <div class="alert-heading h4">
                <i class="fad fa-exclamation-triangle"></i>
                Une commande existe déjà pour ce client
            </div>
            Commande {{ existingOrder.reference }}<br>
            Date de livraison : {{ global.moment(existingOrder.delivery_date).format('dddd Do MMMM YYYY') }}<br>
            Date de fin de préparation : {{ global.moment(existingOrder.end_preparation_date).format('dddd Do MMMM YYYY') }}<br>
            <a class="btn btn-warning mt-2" :href="viewExistingOrderHref(existingOrder)">
                Voir la commande
            </a>
            <a class="btn btn-warning mt-2 ml-2" :href="editExistingOrderHref(existingOrder)">
                Modifier la commande
            </a>
        </div>
    </div>
</template>

<script>
    import ErrorsZone from "./ErrorsZone"

    import {useGetLoader} from "./compositions/axios/loadingRequest";

    export default {
        name: 'CheckExistingOrder',

        components: {
            ErrorsZone,
        },

        setup() {
            const {
                loading,
                errors,
                load,
            } = useGetLoader();

            return {
                loading,
                errors,
                load,
            };
        },

        props: {
            customer: {
                type: Object,
                required: false,
            },
            endPreparationDate: {
                type: String,
                required: false,
            },
            order: {
                type: Object,
                required: false,
            },
            viewExistingOrderHref: {
                type: Function,
                required: true,
            },
            editExistingOrderHref: {
                type: Function,
                required: true,
            },
        },

        data() {
            return {
                existingOrder: null,
            };
        },

        mounted() {
            this.loadExistingOrder();
        },

        watch: {
            customer() {
                this.loadExistingOrder();
            },

            endPreparationDate() {
                this.loadExistingOrder();
            },
        },

        methods: {
            async loadExistingOrder() {
                this.existingOrder = null;

                if(this.customer && this.endPreparationDate) {
                    const response = await this.load(`/espace-employes/commandes/recherche-commande-existante/client/${this.customer.id}/date/${this.endPreparationDate}` + (this.order ? `/ignore-commande/${this.order.id}` : ''));

                    if (response && response.order) {
                        this.existingOrder = response.order;
                    }
                    this.$emit('existing-order-result', { order: this.existingOrder });
                }
            },
        },
    }
</script>
